export default {
  BASKET_ADD: Symbol('BASKET_ADD'),
  BASKET_CHANGED: Symbol('BASKET_CHANGED'),
  BASKET_CLEAR: Symbol('BASKET_CLEAR'),
  BASKET_REMOVE: Symbol('BASKET_REMOVE'),
};
